import { createAsyncThunk } from "@reduxjs/toolkit";
import {axios} from '../../common'
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import OptionHeaders from "../options";
const { token, baseUrl } = OptionHeaders();
const ROLE_DETAIL_SHOW = "roleDetail/show";
const ROLE_DETAIL_CREATE = "roleDetail/create";

export const showRoleDetail = createAsyncThunk(
  ROLE_DETAIL_SHOW,
  async (payload, thunkAPI) => {
    try {
      const dataSource = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}RoleDetail`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
            request.headers["MappedState"] = 1;
          },
        }),
        expand: ["Role,Navigation($expand=items)"],
        filter:
          payload.length > 0 ? ["Role/RoleName eq '" + payload + "'"] : [],
      });
      return dataSource;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const createRoleDetail = createAsyncThunk(
  ROLE_DETAIL_CREATE,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.post(`RoleDetail`, payload);
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
